import React from 'react';
import { Container, List } from '@pella/sash-framework';
import { CTA, Image } from '../../../components';
import PropTypes from 'prop-types';

const VisualNav = ({ placement, pageData }) => {
	const { heading, background_hex_value, offramp } = pageData;

	return (
		<Container
			style={background_hex_value ? { backgroundColor: background_hex_value } : null}
			className={`${placement === 'top' ? 'mb-8 !p-5 md:!p-4 lg:!p-5' : 'md:!bg-transparent'}`}
			id={`visual-nav-${placement}`}
		>
			<div
				className={`${placement === 'bottom' ? 'py-4 md:!p-6' : ''}`}
				style={background_hex_value && placement === 'bottom' ? { backgroundColor: background_hex_value } : null}
			>
				{heading && <h2 className='text-subtitle mb-3 text-center font-bold md:mb-5 md:text-left'>{heading}</h2>}

				<List
					bullets='none'
					className='grid grid-cols-2 gap-2 md:flex md:gap-3 lg:gap-4'
				>
					{offramp.map((card, index) => {
						const { file, heading, cta } = card;

						return (
							<li
								key={index}
								className='flex w-full flex-col'
							>
								<CTA
									data={cta[0]}
									renderAs='link'
									className='grid h-full w-full justify-center border border-neutral-100 bg-white p-3 no-underline hover:underline [&_span]:grid'
								>
									{file?.url && (
										<Image
											data={{ image: file }}
											className={`[&_img]:!object-contain ${placement === 'top' ? 'max-h-16 md:max-h-20 xl:max-h-[88px]' : 'max-h-20 xl:max-h-[120px]'} mb-3 justify-self-center`}
										/>
									)}
									<p className='text-center'>{heading}</p>
								</CTA>
							</li>
						);
					})}
				</List>
			</div>
		</Container>
	);
};

export default VisualNav;

VisualNav.propTypes = {
	placement: PropTypes.oneOf(['top', 'bottom']),
	pageData: PropTypes.object,
};
